module.exports = __webpack_public_path__ + "img/single-neutral-actions-check-1.27a16f4f.svg";